// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtEnrollmentPatientUpdateRequestModel {
    static getAttributeTypeMap() {
        return ExtEnrollmentPatientUpdateRequestModel.attributeTypeMap;
    }
}
ExtEnrollmentPatientUpdateRequestModel.discriminator = undefined;
ExtEnrollmentPatientUpdateRequestModel.additionalProperties = false;
ExtEnrollmentPatientUpdateRequestModel.attributeTypeMap = [
    {
        "name": "clientIdentifiers",
        "baseName": "clientIdentifiers",
        "type": "ExtEnrollmentMedBenClientIdentifiersModel"
    },
    {
        "name": "demographics",
        "baseName": "demographics",
        "type": "ExtEnrollmentPatientUpdateDemographicsModel"
    },
];
//# sourceMappingURL=extEnrollmentPatientUpdateRequestModel.js.map